import { render } from "./VueGeofenciesList.vue?vue&type=template&id=055df171&scoped=true"
import script from "./VueGeofenciesList.vue?vue&type=script&lang=js"
export * from "./VueGeofenciesList.vue?vue&type=script&lang=js"

import "./VueGeofenciesList.vue?vue&type=style&index=0&id=055df171&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055df171"]])

export default __exports__